import {createRouter, createWebHistory, type RouteRecordRaw} from 'vue-router'
import {IndexRoute} from '@/router/index-route';
import {EnterpriseGatewayApiRoute} from '@/router/api-route';
import type {App} from "vue";
import {createAuthGuard} from "@/router/guards/auth-guard.ts";

const router = createRouter({
    history: createWebHistory(),
    routes: getAllRoutes(),
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {left: 0, top: 0};
        }
    }
});

function getAllRoutes(): RouteRecordRaw[] {
    return [
        IndexRoute,
        EnterpriseGatewayApiRoute,
        ...getModuleRoutes(),
        {path: '/:pathMatch(.*)', redirect: '/404'},
    ];
}

function getModuleRoutes(): RouteRecordRaw[] {
    const routeFiles = import.meta.glob(
        '@/app/**/*-routes.ts',
        { eager: true }
    );

    const routes: RouteRecordRaw[] = [];
    Object.entries(routeFiles).forEach(([key, m]) => {
        (m as any).default.forEach((route: RouteRecordRaw) => {
            routes.push(route);
        });
    });
    return routes;
}

export default {
    install(app: App): void {
        router.beforeEach(createAuthGuard());
        app.use(router);
    }
};

